

export function getTrickDifficultyColor(difficultyId: number | undefined) {

    switch (difficultyId) {
        case 1:
            return "rgba(0, 191, 255, 0.7)";
        case 2:
            return "rgba(50, 205, 50, 0.7)";
        case 3:
            return "rgba(210, 105, 30,0.7)";
        case 4:
            return "rgba(255, 0, 0, 0.7)";
        case 5:
            return "rgba(186, 85, 211, 0.7)";
        default:
            return "rgba(122,122,122,0.7)"
    }
}